import { isBrowser } from './window';

export const loseFocusFromActiveElement = () => {
  if (isBrowser()) {
    const elem = document.activeElement;
    if (elem) {
      (elem as HTMLElement)?.blur();
    }
  }
};
